<template>
    <div class="gcmcn-card-gradient manager-list">
        <user-form
            v-if="displayFormView"
            :users="usersFiltered"
            @on-user-created="onUserCreated"
            @leave-form-view="displayFormView = false"
        ></user-form>
        <user-reset-password
            v-else-if="displayFormResetUserPassword"
            :user="selectedUser"
            @on-user-updated="displayFormResetUserPassword = false"
            @leave-form-view="displayFormResetUserPassword = false"
        ></user-reset-password>
        <template v-else>
            <el-button
                type="primary"
                class="gcmcn-primary-btn small add-user-btn"
                icon="el-icon-plus"
                @click="onUserCreation">
            </el-button>
            <div class="user-count">{{ userAdmins.length }} admin{{ userAdmins.length > 1 ? 's' : '' }}</div>
            <gcmcn-filters
                :filter-values="[selectedSortType, searchFilter]"
                @reset-filters="resetFilters"
                style="margin-top: 0;"
            >
                <dropdown
                    name="Sort"
                    :multiple="false"
                    :list="$store.getters.sortTypeList"
                    itemName="name"
                    itemValue="value"
                    :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                    @on-select-item="selectedSortType = $event"
                ></dropdown>
                <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
            </gcmcn-filters>
            <template v-if="usersFiltered.length > 0">
                <user-card
                    v-for="user in usersFiltered"
                    :key="user.uid"
                    :user="user"
                    @editUserPassword="onUserChangePassword"
                    @deleteUser="deleteUser"
                ></user-card>
            </template>
            <template v-else-if="searchFilter">
                <p class="list-empty">No admin matching this filter</p>
            </template>
        </template>
    </div>
</template>

<script>
import UserCard from './user-card.vue';
import UserForm from './user-form.vue';
import UserResetPassword from '../../Takers/user-change-password.vue';

import { GcmcnFilters, Dropdown, SearchFilter } from 'gcmcn-common';
export default {

    components: {
        UserCard,
        GcmcnFilters,
        Dropdown,
        SearchFilter,
        UserResetPassword,
        UserForm,
    },

    props: {
    },

    data (){
        return {
            selectedSortType: '',
            searchFilter: '',
            displayFormResetUserPassword: false,
            selectedUser: null,
            displayFormView: false,
        };
    },

    computed: {
        userAdmins (){
            return this.$store.getters.users.filter((u) => u.level === 'admin');
        },

        usersFiltered (){
            let users = this.userAdmins.slice();
            if(this.selectedSortType){
                users.sort((a, b) => a.verbose_name.localeCompare(b.verbose_name));
                if(this.selectedSortType === 'dsc'){
                    users.reverse();
                }
            }
            if(this.searchFilter){
                users = users.filter((u) => u.verbose_name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return users;
        },
    },

    mounted (){

    },

    methods: {
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        onUserCreation (){
            this.displayFormView = true;
        },
        onUserCreated (){
            this.displayFormView = false;
        },
        onUserChangePassword (user){
            this.$set(this, 'selectedUser', user);
            this.displayFormResetUserPassword = true;
        },

        deleteUser (user){
            this.$store.dispatch('deleteItem', {
                item: {
                    uid: user.uid,
                    url: user.url,
                },
                model: 'users'
            }).then(() => {
                this.$notify.success({
                    title: 'Success',
                    message: 'User has been deleted'
                });
            }).catch(() => {
                this.$notify.error({
                    title: 'Error',
                    message: 'User couldn\'t be deleted'
                });
            });
        },
    },
};
</script>

<style lang="scss">
.add-user-btn{
    display: flex;
    margin-left: auto;
    i{
        margin-right: 0;
    }
}
.user-count{
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Setting/Users/index.vue